import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { Row, Col, Container } from "reactstrap";
import { Route } from "react-router-dom";

// Layout
import AppHeader from "../../Layout/AppHeader/";
import UserManagement from "../../OneLIS/DMS/ConfigCatalog/UserManagement/User/userManagement";
import CreateManagement from "../../OneLIS/DMS/ConfigCatalog/UserManagement/User/createModal.js";


// Theme Options
import ThemeOptions from "../../Layout/ThemeOptions/";
import SidList from "../../../src/Views/Sid/SidList";
import UserBox from "../../../src/Layout/AppHeader/Components/UserBox";
import * as configApi from "../../config/configApi.js";
import "../../Template/Style/base.css";
import AppSidebar from "../../Layout/AppSidebar/";
function usermanagementview(props) {
  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <div className="app-main__outer">
          <div className="app-main__inner">
          {" "}
          <UserManagement />
          {/* <CreateManagement/> */}
          </div>
        </div>
      </div>
    </Fragment>
  );
}
//export default Checking;
const mapStateToProps = (state) => ({ global: state.global });
export default connect(mapStateToProps)(usermanagementview);

